/**
 * Given a target bounding rectangle, position another bounding rectangle alongside it so that it fits in a preferred orientation so long as it sits within the client window
 * - If the preferred orientation does not fit in the client window, then the next preferred position clockwise around the target will be chosen
 * - If no orientations fit in the client window, then just return the preferred orientation anyway
 */
export function getPosition(preferredOrientation, layout) {
	var position = null;
	position = calculatePosition(preferredOrientation, layout);

	// If preferredPosition does not fit within the bounds of the window
	var positionFits = fitsWithinWindow(position, layout);
	
	// Re-test on another preferredOrientation
	if(!positionFits) {
		for(var i = 0; i < orientations.length; i++) {
			var fallbackPosition = calculatePosition(orientations[i], layout);
			positionFits = fitsWithinWindow(fallbackPosition, layout);
	
			if(positionFits) {
				return {
					style: fallbackPosition,
					orientation: orientations[i]
				}
			}
		}
	}
	
	// Continue until one that fits is found otherwise return original position
	return {
		style: position,
		orientation: preferredOrientation
	};
}

/**
 * @param elem DOMElement
 * @param ancestor DOMElement
 * @return object
 */
export function getOffsetsRelevantToAncestor(elem, ancestor) {
    var offsetLeft = 0;
    var offsetTop = 0;

    while (true)
    {
        offsetLeft += elem.offsetLeft;
        offsetTop += elem.offsetTop;

        if (elem.parentElement == ancestor
        	|| elem.offsetParent == null
        	|| elem.offsetParent.contains(ancestor)) //make sure we haven't traversed outside of our ancestor
        {
            break;
        }

        elem = elem.offsetParent;
    }

    return { top: offsetTop, left: offsetLeft };

} 

/**
 * @param orientation string
 * @param layout object
 * @return object
 */
export function calculatePosition(orientation, layout) {
	var x, y = 0;

	switch(orientation) {
		case 'top-left':
			x = layout.targetLeft;
			y = layout.targetTop - layout.subjectHeight;
			break;
		case 'top-right':
			x = layout.targetRight - layout.subjectWidth;
			y = layout.targetTop - layout.subjectHeight;
			break;
		case 'top-middle':
			x = layout.targetLeft + (layout.targetWidth / 2) - (layout.subjectWidth / 2);
			y = layout.targetTop - layout.subjectHeight;
			break;
		case 'bottom-left':
			x = layout.targetLeft;
			y = layout.targetBottom;
			break;
		case 'bottom-middle':
			x = layout.targetLeft + (layout.targetWidth / 2) - (layout.subjectWidth / 2);
			y = layout.targetBottom;
			break;
		case 'bottom-right':
			x = layout.targetRight - layout.subjectWidth;
			y = layout.targetBottom;
			break;
		case 'left-top':
			x = layout.targetLeft - layout.subjectWidth;
			y = layout.targetTop;
			break;
		case 'left-middle':
			x = layout.targetLeft - layout.subjectWidth;
			y = layout.targetTop + (layout.targetHeight / 2) - (layout.subjectHeight / 2)
			break;
		case 'left-bottom':
			x = layout.targetLeft - layout.subjectWidth;
			y = layout.targetBottom - layout.subjectHeight;
			break;
		case 'right-top':
			x = layout.targetRight;
			y = layout.targetTop;
			break;
		case 'right-middle':
			x = layout.targetRight;
			y = layout.targetTop + (layout.targetHeight / 2) - (layout.subjectHeight / 2);
			break;
		case 'right-bottom':
			x = layout.targetRight;
			y = layout.targetBottom - layout.subjectHeight;
			break;
	}

	return { top: y, left: x };
}

/**
 * @param proposedPosition
 * @param layout
 * @return boolean TRUE if the layout will fit in the proposed position inside the client window dimensions
 */
export function fitsWithinWindow(proposedPosition, layout) {
	var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	var dx = Math.max(document.documentElement.scrollLeft, window.pageXOffset || 0);
	var dy = Math.max(document.documentElement.scrollTop, window.pageYOffset || 0);
	
	var debug = false;
	if(debug) {
		console.log("COORDS: Proposed position", proposedPosition, layout);
		console.log("COORDS: Viewport width " + w + " height " + h);
		console.log("COORDS: Current scroll x " + dx + " y " + dy );
	}

	// Current issue here is that proposedPosition is not relative position to the document root
	// So any coordinate conversion is not going to be correct
	
	// Right edge of subject is outside client viewport
	if(proposedPosition.left + layout.subjectWidth > w + 0) {
		if(debug) console.log("OUTSIDE: right");
		return false;
	} 
	// Left edge of subject is outside left part of client viewport
	else if(proposedPosition.left < 0) {
		if(debug) console.log("OUTSIDE: left");
		return false;
	}
	// Top edge is outside top part of client viewport
	else if(proposedPosition.top < 0) {
		if(debug) console.log("OUTSIDE: top");
		return false;
	}
	else if(proposedPosition.top + layout.subjectHeight > h + 0) {
		if(debug) console.log("OUTSIDE: bottom");
		return false;
	}

	return true;
}

var orientations = [
	'top-left',
	'top-right',
	'top-middle',
	'bottom-left',
	'bottom-middle',
	'bottom-right',
	'left-top',
	'left-middle',
	'left-bottom',
	'right-top',
	'right-middle',
	'right-bottom'
];


// WEBPACK FOOTER //
// ./app/b3/misc/Coords.js